enum AccountType {
    PAYABLE = 'P',
    RECEIVABLE = 'R',
    INVOICE = 'I',
  }

  export default AccountType;
